import React from 'react';
import ReactDOM from 'react-dom/client';
// import { Provider } from "react-redux";
// import { PersistGate } from "redux-persist/es/integration/react";
// import store, { persistor } from "./redux/store";
import { RouterProvider } from "react-router-dom";
import router from "./router";
import { Helmet, HelmetProvider } from "react-helmet-async";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  ChakraProvider, 
  UseToastOptions,
} from "@chakra-ui/react";
import "./reset.css";
import { ScreenProvider } from './components/ScreenProvider';
import { DarkModeProvider } from './components/DarkModeProvider';
import { theme } from './components/ResponsiveUiComponent';
import GlobalStyle from './components/GlobalStyles';
import { BrowserProvider } from './components/BrowserProvider';

declare global {
  interface Window {
    Kakao: any;
    kakao: any;
  }
}

const options: UseToastOptions = { position: "top", variant: "solid", duration: 2000 };   // variant: "subtle"

const client = new QueryClient();

const head = document.querySelector("head");
// head.innerHTML = "<link rel='stylesheet' as='style' crossorigin href='https://cdn.jsdelivr.net/gh/orioncactus/pretendard@v1.3.8/dist/web/static/pretendard.css' />";
head.innerHTML = "<link rel='stylesheet' as='style' crossorigin href='https://cdn.jsdelivr.net/gh/orioncactus/pretendard@v1.3.8/dist/web/static/pretendard.css' /><link rel='stylesheet' type='text/css' charset='UTF-8' href='https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.8.1/slick.min.css'/><link rel='stylesheet' type='text/css' charset='UTF-8' href='https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.8.1/slick-theme.min.css'/>";

const style = document.createElement("style");
if (head) {
  head.appendChild(style);
}

const html = document.querySelector("html");
html.style.width = "100%";
html.style.height = "100%";

const body = document.querySelector("body") as HTMLBodyElement;
body.style.margin = "0";
body.style.width = "100%";
body.style.height = "100%";
body.style.fontFamily = "TbellFont";
body.style.fontSize = "clamp(0.75rem, 0.6346rem + 0.5128vw, 1.25rem)";

const rootEl = document.getElementById('root') as HTMLElement;
const root = ReactDOM.createRoot(rootEl);

rootEl.style.height = "100%";
rootEl.style.display = "flex";
rootEl.style.flexDirection = "column";
rootEl.style.justifyContent = "space-between";

root.render(
  <HelmetProvider>
    <Helmet>
      <title>TBELL</title>
    </Helmet>
    <GlobalStyle />
    <ToastContainer position={"top-right"} autoClose={2000} />
    <QueryClientProvider client={client}>
      {/* <Provider store={store}> */}
        {/* <PersistGate persistor={persistor}> */}
          <ChakraProvider theme={theme} toastOptions={{ defaultOptions: options }}>
            <DarkModeProvider>
              <BrowserProvider />
              <ScreenProvider>
                <RouterProvider router={router} />
              </ScreenProvider>
            </DarkModeProvider>
          </ChakraProvider>
        {/* </PersistGate> */}
      {/* </Provider> */}
    </QueryClientProvider>
  </HelmetProvider>
);